// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Typography, useMediaQuery} from '@material-ui/core';
import CustomButton from '../CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../CustomModal/CustomModal';
import {colors} from '../../assets/styles/colors';

import tierRestrictionModalImg1 from '../../assets/img/premiumFeatureIcons/dollar-tag 1.png';
import tierRestrictionModalImg2 from '../../assets/img/premiumFeatureIcons/Group 1260.png';
import tierRestrictionModalImg3 from '../../assets/img/premiumFeatureIcons/choose 1.png';
import tierRestrictionModalImg4 from '../../assets/img/premiumFeatureIcons/quantity 1.png';
import tierRestrictionModalImg5 from '../../assets/img/premiumFeatureIcons/009-order-tracking 1.png';
import tierRestrictionModalImg6 from '../../assets/img/premiumFeatureIcons/Chat.png';
import tierRestrictionModalImg7 from '../../assets/img/premiumFeatureIcons/email 1.png';
import tierRestrictionModalImg8 from '../../assets/img/premiumFeatureIcons/settings 1.png';

type Props = {
  open: boolean,
  handleClose: () => void,
};
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 670,
    padding: theme.spacing(4, 2, 1, 2),
  },
  title: {
    textAlign: 'center',
    fontWeight: 600,
    // margin: theme.spacing(2),
  },
  description: {
    textAlign: 'center',
    fontSize: '0.875rem',
    color: colors.grey800,
  },
  tierRestrictionModalContent: {
    margin: theme.spacing(4, 0),
    overflowX: 'hidden',
    [theme.breakpoints.down('xs')]: {
      maxHeight: 'calc(100vh - 300px)',
      overflowY: 'auto',
      margin: theme.spacing(3, 0),
    },
  },
  tierRestrictionModalTitle: {
    maxWidth: 450,
    textAlign: 'center',
    fontWeight: 600,
  },
  tierRestrictionModalItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '.75rem',

    '& img': {
      width: 40,
      height: 40,
    },
  },
  tierRestrictionModalText: {
    color: colors.grey700,
    fontSize: '0.875rem',
    lineHeight: '22px',
  },
  button: {
    height: 40,
    // marginTop: theme.spacing(2),
    fontSize: '1rem',
    fontWeight: 600,
    padding: '6px 50px',
  },
}));

export default function TierRestrictionModal(props: Props) {
  const {open, handleClose} = props;
  const classes = useStyles();

  const mobile = useMediaQuery('(max-width:600px)');

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography className={classes.title}>
          Esta funcionalidad es de TiendaDa PRO
        </Typography>
        <Typography className={classes.description}>
          Mejora tu plan para empezar a utilizarla y muchas más.
        </Typography>
        <div className={classes.tierRestrictionModalContent}>
          <Grid container spacing={mobile ? 2 : 4}>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg1} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Precios al por mayor
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg2} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Elementos destacados
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg3} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Variantes de productos como tallas, colores y más
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg4} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Gestión de inventarios, realiza seguimiento de las unidades
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg5} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Gestión de pedidos con seguimiento por estados y más
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg6} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Reseñas porque nada vende más que la opinion de un cliente
                  feliz
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg7} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Automatización de correos
                </Typography>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div className={classes.tierRestrictionModalItem}>
                <img src={tierRestrictionModalImg8} alt="" />
                <Typography className={classes.tierRestrictionModalText}>
                  Configuraciones avanzadas de métodos de pago, envíos y más
                </Typography>
              </div>
            </Grid>
          </Grid>
        </div>
        <CustomButton
          variant="contained"
          className={classes.button}
          to="/tiers-list"
          onClick={handleClose}
        >
          Ver planes
        </CustomButton>
        <CustomButton onClick={handleClose}>Cerrar</CustomButton>
      </div>
    </CustomModal>
  );
}

TierRestrictionModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};
